<template>
  <div class="container mt-3">
    <div class="title is-4">{{ $t("pensum information") }}</div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label" for="">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label" for="">{{ $t("options") }}</label>
          <div class="buttons">
            <button class="button is-primary is-rounded" @click="save">
              <span class="icon">
                <i class="fa fa-save"></i>
              </span>
              <span>{{ $t("save") }}</span>
            </button>
            <div class="button" @click="cancel" :data-tooltip="$t('cancel')">
              <span class="icon">
                <i class="fa fa-times"></i>
              </span>
            </div>
            <div
              class="button is-danger"
              @click="remove"
              v-show="uuid"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title is-4">{{ $t("courses") }}</div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('course')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/student/course/catalog"
            name_field="name"
            value_field="course_id"
            @selected="course_changed"
            ref="course_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('stage')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/student/stage/catalog"
            name_field="name"
            value_field="stage_id"
            @selected="stage_changed"
            ref="stage_dropdown"
          />
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label" for="">{{ $t("options") }}</label>
          <button
            class="button is-primary is-rounded"
            @click="add_course"
            :disabled="!current_course || !current_stage"
          >
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>{{ $t("add") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- <pre>{{ grouped }}</pre> -->
    <div class="columns is-multiline">
      <div
        class="column is-half"
        v-for="(courses, stage) in grouped"
        :key="stage"
      >
        <div class="box content">
          <div class="title is-5">{{ stage }}</div>
          <ul>
            <li v-for="(course, idx) in courses" :key="idx">
              <div
                class="button is-small is-danger is-pulled-right py-1"
                @click="remove_course(stage, course.course)"
              >
                <span class="icon">
                  <i class="fa fa-times"></i>
                </span>
              </div>
              <span>{{ course.course.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";
import {
  post,
  put,
  error_message,
  confirm_deletion_dialog,
  del,
} from "@/utils";

export default {
  name: "Pensum",
  components: { GenericDropdown },
  data() {
    return {
      current_course: undefined,
      current_stage: undefined,
      course_list: [],
      meta: {
        settings: {},
      },
      uuid: undefined,
    };
  },
  computed: {
    grouped() {
      return groupBy(this.course_list, (item) => {
        return item.stage.name;
      });
    },
  },
  methods: {
    set_pensum(pensum) {
      let v = this;
      v.meta = {
        name: pensum.name,
        program_id: pensum.program_id,
        settings: pensum.settings,
      };
      v.uuid = pensum.uuid;
      v.course_list = pensum.student_pensum_courses.map((c) => {
        return {
          course: c.course,
          stage: c.stage,
        };
      });
    },
    set_program(program_id) {
      let v = this;
      v.meta.program_id = program_id;
    },
    set_pensum_uuid(uuid) {
      let v = this;
      v.uuid = uuid;
    },
    course_changed(course) {
      let v = this;
      v.current_course = course;
    },
    stage_changed(stage) {
      let v = this;
      v.current_stage = stage;
    },
    add_course() {
      let v = this;
      let element = {
        course: v.current_course,
        stage: v.current_stage,
      };
      v.course_list.push(element);

      v.$refs.course_dropdown.clear();
      //   v.$refs.stage_dropdown.clear();
      v.current_course = undefined;
      //   v.current_stage = undefined;
    },
    save() {
      let v = this;
      if (v.uuid) {
        put("/student/pensum", {
          ...v.meta,
          pensum: v.course_list.map((c) => {
            return {
              course_id: c.course.course_id,
              stage_id: c.stage.stage_id,
            };
          }),
          uuid: v.uuid,
        })
          .then((response) => {
            v.init_state();
            v.$emit("success");
          })
          .catch((error) => {
            error_message(error);
          });
      } else {
        post("/student/pensum", {
          ...v.meta,
          pensum: v.course_list.map((c) => {
            return {
              course_id: c.course.course_id,
              stage_id: c.stage.stage_id,
            };
          }),
        })
          .then((response) => {
            v.init_state();
            v.$emit("success");
          })
          .catch((error) => {
            error_message(error);
          });
      }
    },
    cancel() {
      let v = this;
      v.init_state();
      v.$emit("cancel");
    },
    init_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.uuid = undefined;
      v.course_list = [];
      v.current_course = undefined;
      v.current_stage = undefined;
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete pensum?"), v, () => {
        del("/student/pensum", { uuid: v.uuid })
          .then(() => {
            v.$emit("success");
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    remove_course(stage, course) {
      let v = this;
      let index = v.course_list.findIndex((c) => {
        return c.course.course_id == course.course_id && c.stage.name == stage;
      });
      if (index > -1) {
        v.course_list.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped></style>
